document.addEventListener(
  'DOMContentLoaded',
  () => {
    // 定义需要查找的section id数组
    const sectionIds = [
      'shopify-section-template--20973701398767__rich_text_77QRh7',
      'shopify-section-template--20973701398767__rich_text_qEmKAL',
      'template--20973701398767__rich_text_zh8hGe',
    ];

    // 解析 JWT Payload
    function parseJwtPayload(token) {
      try {
        // 1. 拆分 Token，取 Payload（第二段）
        const parts = token.split('.');
        if (parts.length !== 3) {
          throw new Error('无效的 JWT 格式（非三段式）');
        }
        const payloadBase64Url = parts[1];

        // 2. Base64URL 转 标准 Base64
        const payloadBase64 = payloadBase64Url
          .replace(/-/g, '+') // 替换 - 为 +
          .replace(/_/g, '/') // 替换 _ 为 /
          .padEnd(
            payloadBase64Url.length + ((4 - (payloadBase64Url.length % 4)) % 4),
            '='
          ); // 补充填充符 =

        // 3. atob 解码 + 转 UTF-8 字符串 + 解析 JSON
        const payloadStr = decodeURIComponent(
          atob(payloadBase64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        return JSON.parse(payloadStr);
      } catch (err) {
        console.error('解析 JWT 失败：', err.message);
        return { user_name: '' };
      }
    }

    // AES 加密函数（兼容 Java 的 AES/CBC/NoPadding）
    function aesEncrypt(data, keyStr, ivStr) {
      // 检查 CryptoJS 是否已加载
      if (typeof CryptoJS === 'undefined') {
        throw new Error(
          'CryptoJS 未加载，请先引入: https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.1.1/crypto-js.min.js'
        );
      }

      // 手动进行 Zero Padding
      const blockSize = 16;
      const dataBytes = new TextEncoder().encode(data);
      let plaintextLength = dataBytes.length;

      if (plaintextLength % blockSize !== 0) {
        plaintextLength =
          plaintextLength + (blockSize - (plaintextLength % blockSize));
      }

      const plaintext = new Uint8Array(plaintextLength);
      plaintext.set(dataBytes);

      // 将 Uint8Array 转为 CryptoJS 的 WordArray
      const wordArray = CryptoJS.lib.WordArray.create(plaintext);
      const keyWordArray = CryptoJS.enc.Utf8.parse(keyStr);
      const ivWordArray = CryptoJS.enc.Utf8.parse(ivStr);

      // 使用 CryptoJS 加密，NoPadding
      const encrypted = CryptoJS.AES.encrypt(wordArray, keyWordArray, {
        iv: ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.NoPadding,
      });

      // 转为 Base64 URL Safe 格式
      const base64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
      return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    // 获取token
    function getToken() {
      const itemStr = window.localStorage.getItem('atotoToken');
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date().getTime();

      // 检查数据是否过期
      if (now > item.expiry) {
        window.localStorage.removeItem('atotoToken');
        return null;
      }

      return item.value;
    }

    // 遍历所有的section id
    sectionIds.forEach((sectionId) => {
      const reviewsContainer = document.getElementById(sectionId);
      if (!reviewsContainer) {
        return;
      }

      const targetLinks = reviewsContainer.querySelectorAll('a');

      // const targetLinks = reviewsContainer.querySelectorAll(
      //   'a[href="https://www.eproductcare.com/question/surveyform"]'
      // )

      if (targetLinks.length === 0) {
        return;
      }

      targetLinks.forEach((link) => {
        // 如果链接已经有href且不为空,跳过处理
        if (link.href && link.href.trim() !== '') {
          return;
        }

        // const targetUrl = 'https://test-aboss.myatoto.cn/question/surveyform';
        const targetUrl = 'https://www.eproductcare.com/question/surveyform';

        // 配置加密参数
        const key = 'atoto12345678901';
        const iv = '1234567887654321';

        const urlParams = {
          qid: '46',
          ticketNumber: '',
          serialNumber: '',
          platCode: 'indiegogo',
          indiegogoCode: '7EH1MaTdbUStuym4HhcRKw',
          indiegogoCodeSource: 'atotodirect',
          indiegogoCodeEmail: '',
        };

        try {
          // 尝试从 localStorage 获取用户信息
          const tokenStr = getToken();
          if (tokenStr) {
            const userInfo = parseJwtPayload(tokenStr);
            const email = userInfo.user_name;
            if (email) {
              urlParams.indiegogoCodeEmail = email;
            }
          }
        } catch (error) {
          console.error('解析 Token 失败:', error);
        }

        // 将参数对象转换为查询字符串
        const queryString = JSON.stringify(urlParams);

        // 使用 AES 加密
        try {
          const encryptedParams = aesEncrypt(queryString, key, iv);

          // 构建跳转链接并替换原有的href
          const redirectUrl = `${targetUrl}?data=${encryptedParams}`;
          link.href = redirectUrl;
          // 移除标签的aria-disabled属性
          link.removeAttribute('aria-disabled');
        } catch (error) {
          console.error('加密失败:', error);
        }
      });
    });
  },
  { once: true }
);
